import { useMemo } from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  useSidebar,
} from '@/components/ui/sidebar'
import { useAuthStore } from '@/features/auth/store/auth-store'
import { useSessionsAction } from '../hooks/useSessionsAction'
import { useSessionsStore } from '../stores/sessions-store'
import { DeleteSessionDialog } from './delete-session-dialog'
import { SessionItemExpanded, SessionItemCollapsed } from './session-item'

export function SessionsNav() {
  const { state, isMobile } = useSidebar()
  const { user } = useAuthStore((s) => s.auth)
  const searchQuery = useSessionsStore((s) => s.searchQuery)
  const setSearchQuery = useSessionsStore((s) => s.setSearchQuery)

  const {
    sessionList,
    navigateToSession,
    openDeleteDialog,
    confirmDeleteSession,
  } = useSessionsAction()

  // 根据搜索关键词过滤会话列表
  const filteredSessions = useMemo(() => {
    if (!sessionList || sessionList.length === 0 || !user) return []
    if (!searchQuery.trim()) return sessionList

    const query = searchQuery.toLowerCase()
    return sessionList.filter((session) =>
      session.engine.engineTitle.toLowerCase().includes(query)
    )
  }, [sessionList, searchQuery, user])

  // 判断是否处于折叠状态（非移动端且侧边栏收起）
  const isCollapsed = state === 'collapsed' && !isMobile

  return (
    <SidebarGroup>
      <SidebarGroupLabel>足迹</SidebarGroupLabel>

      {/* 搜索框 - 仅在展开状态下显示 */}
      {!isCollapsed && (
        <div className='px-2 pb-2'>
          <div className='relative'>
            <Search className='text-muted-foreground absolute top-1/2 left-2 h-4 w-4 -translate-y-1/2' />
            <Input
              placeholder='搜索'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className='h-8 pl-8 text-sm'
            />
          </div>
        </div>
      )}

      {/* 会话列表 */}
      <SidebarMenu>
        {filteredSessions.map((session) =>
          isCollapsed ? (
            <SessionItemCollapsed
              key={session.sessionId}
              session={session}
              onNavigate={navigateToSession}
              onDelete={openDeleteDialog}
            />
          ) : (
            <SessionItemExpanded
              key={session.sessionId}
              session={session}
              onNavigate={navigateToSession}
              onDelete={openDeleteDialog}
            />
          )
        )}

        {/* 空状态提示 - 仅在展开状态下显示 */}
        {!isCollapsed && filteredSessions.length === 0 && (
          <div className='text-muted-foreground px-2 py-4 text-center text-sm'>
            {searchQuery ? '未找到匹配的会话' : '暂无会话记录'}
          </div>
        )}
      </SidebarMenu>

      {/* 删除确认对话框 */}
      <DeleteSessionDialog onConfirm={confirmDeleteSession} />
    </SidebarGroup>
  )
}
